import { useEffect, useRef, useState } from "react";
import { API_BASE_URL } from "../api/http";

const WS_BASE_URL = API_BASE_URL.replace(/^http/i, "ws");

export default function useChatOnlineSocket(chatId, { onUpdate } = {}) {
  // خیلی مهم:
  // socketRef باید داخل خود Hook باشد تا notifyUpdate به آن دسترسی داشته باشد.
  const socketRef = useRef(null);
  const onUpdateRef = useRef(onUpdate);

  const [status, setStatus] = useState("idle");

  // همیشه آخرین onUpdate را نگه می‌داریم
  onUpdateRef.current = onUpdate;

  useEffect(() => {
    if (!chatId) {
      setStatus("idle");
      socketRef.current = null;
      return;
    }

    let socket = null;
    let closedByCleanup = false;
    let reconnectTimer = null;

    const connect = () => {
      if (closedByCleanup) {
        return;
      }

      socket = new WebSocket(`${WS_BASE_URL}/ws/chat-online/${chatId}/`);

      socketRef.current = socket;

      setStatus("connecting");

      socket.onopen = () => {
        setStatus("open");
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data.type === "chat_updated") {
            onUpdateRef.current?.();
          }
        } catch (error) {
          console.error("WebSocket message parse error:", error);
        }
      };

      socket.onerror = (error) => {
        console.error("Chat WebSocket error:", error);

        // onclose بعد از close اجرا می‌شود
        socket.close();
      };

      socket.onclose = () => {
        if (socketRef.current === socket) {
          socketRef.current = null;
        }

        setStatus("closed");

        if (!closedByCleanup) {
          reconnectTimer = setTimeout(() => {
            connect();
          }, 3000);
        }
      };
    };

    connect();

    return () => {
      closedByCleanup = true;

      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
      }

      if (socketRef.current === socket) {
        socketRef.current = null;
      }

      if (socket) {
        socket.close();
      }
    };
  }, [chatId]);

  /**
   * بعد از ارسال موفق پیام توسط API،
   * به WebSocket اطلاع می‌دهیم که chat تغییر کرده.
   */
  const notifyUpdate = () => {
    const socket = socketRef.current;

    // هنوز WebSocket وصل نشده
    if (!socket) {
      console.warn("Chat WebSocket is not connected.");
      return false;
    }

    // WebSocket هنوز آماده ارسال نیست
    if (socket.readyState !== WebSocket.OPEN) {
      console.warn(
        "Chat WebSocket is not open. Current state:",
        socket.readyState,
      );

      return false;
    }

    socket.send(
      JSON.stringify({
        type: "chat_updated",
        chat_id: chatId,
      }),
    );

    return true;
  };

  return {
    status,
    notifyUpdate,
  };
}
